import React, { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';

import { withProcedureWraper } from '..'
import { Routes } from '../../../AppRoutes';
import { Box } from '../../../components/box';
import { Icon } from '../../../components/icon';
import { getDiffDay, getHHmmFormat } from '../../../helper/dateTimeHelper';
import { getLocaleKey } from '../../../languages';
import { Button } from '../../../modules/button';
import { Message } from '../../../modules/message';
import { EventsService } from '../../../services/events/events.service';
import { Chrono } from "react-chrono";

const filters = [
  { id: 1, name: "Hôm nay", value: 'today' },
  { id: 2, name: "Tuần này", value: 'thisweek' },
  { id: 3, name: "Tháng này", value: 'thismonth' },
]

export const ProcedureMeetingPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const [events, setEvents] = useState(null as any);
  const [errorMessage, setErrorMessage] = useState(null as any);
  const [filterSelect, setFilterSelect] = useState(filters[0]);

  const fetchData = async () => {
    EventsService.getEvents(filterSelect.value).then(res => {
      const data = res.map((event: any) => ({
        ...event,
        title: `${new Date(event.start.dateTime).toLocaleDateString(getLocaleKey())} | ${event.isAllDay ? 'Cả ngày | ' + getDiffDay(event.start.dateTime, event.end.dateTime) + ' ngày' : getHHmmFormat(event.start.dateTime) + '-' + getHHmmFormat(event.end.dateTime)}`,
      }))
      setEvents(data);
    }, error => {
      setErrorMessage(error.message)
    });
  }

  const onFilterChange = (filter: any) => {
    setFilterSelect(filter);
  }

  useEffect(() => {
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterSelect]);

  return (
    <div className="ProcedureMeetingPage">
      <div className="pd15">
        <Box
          title="Cuộc họp"
          titleRight={<div className="btnPlus" onClick={() => history.push(Routes.procedureMeetingCreate.path.replace(':id', '0'))}>
            <Icon.Plus /> Tạo cuộc họp
          </div>}
        >
          {(() => {
            if (!events) return <Message type="loading" />
            if (errorMessage) return <Message type="error" message={errorMessage} />
            return (
              <>
                <div className="filter-container d-flex justify-content-center">
                  {
                    filters.map(filter => (
                      <div className="px-3" key={filter.id}>
                        <Button
                          buttonType={filter.id === filterSelect.id ? 'dark' : 'dark-outline'}
                          label={filter.name}
                          onClick={() => { onFilterChange(filter) }}
                        />
                      </div>
                    ))
                  }
                </div>
                {
                  events && events.length === 0 &&
                  <div className="no-data-found">
                    {'Không có cuộc họp nào'}
                  </div>
                }
                <div className="event-time-line d-flex justify-content-center py-4">
                  <Chrono
                    allowDynamicUpdate={true}
                    items={events}
                    mode="VERTICAL"
                    hideControls={true}
                    slideShow={false}
                  >
                    {events.map((item: any, key: number) => {
                      return (
                        <div className="event-time-line__item" key={key}>
                          <div className="event-time-line__item__content">
                            {/* <div className="event-time">{item.isAllDay ? 'Cả ngày' : `${getHHmmFormat(item.start.dateTime)} - ${getHHmmFormat(item.end.dateTime)}`}</div> */}
                            <div className="event-title">{item.subject}</div>
                            <div className="event-attendees">
                              {item.attendees.map((attendee: any, attendeeKey: number) => {
                                return (
                                  <div className="event-attendees__item" key={attendeeKey}>
                                    • {attendee.emailAddress.name}
                                  </div>
                                )
                              })}
                            </div>
                            <Button
                              buttonType="info-outline"
                              label="Chi tiết"
                              onClick={() => history.push(Routes.procedureMeetingDetail.path.replace(':id', item.id))}
                            />
                          </div>
                        </div>
                      )
                    })}
                  </Chrono>
                </div>
              </>
            )
          })()}
        </Box>
      </div>
    </div>
  )
})